import { Link } from 'react-router-dom';

interface ButtonProps {
  text: string;
  to?: string;
  onClick?: () => void;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({ text, to, onClick, disabled = false }) => {
  if (to) {
    return (
      <Link to={to} className="button">
        {text}
      </Link>
    );
  }

  return (
    <button className="button" onClick={onClick} disabled={disabled}>
      {text}
    </button>
  );
};

export default Button;
